import { render } from "./AreaManagerPanel.vue?vue&type=template&id=3441027e&scoped=true"
import script from "./AreaManagerPanel.vue?vue&type=script&lang=js"
export * from "./AreaManagerPanel.vue?vue&type=script&lang=js"

import "./AreaManagerPanel.vue?vue&type=style&index=0&id=3441027e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3441027e"]])

export default __exports__